<template>
	<div class="p-p-2 child-content">
		<SystemCsvTranslationExport
			:fileTypes="fileTypes"
			@startTranslationFileDownload="startTranslationFileDownload"
		/>
	</div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import SystemCsvTranslationExport from "@/apps/administration/components/system/SystemCsvTranslationExport.vue";
import {ClientManager} from "@/singletons/ClientManager";
import {ToastManager} from "@/util/ToastManager";

export default defineComponent({
	name: "TranslationExportView",
	components: {
		SystemCsvTranslationExport,
	},
	setup() {
		const {t} = useI18n();
		const toast = useToast();

		/** Show Loading on download */
		const loading = ref(false);

		/** Api for translations */
		const translationsApi = ClientManager.getInstance().squeeze.translations;

		/** List with Available File-Types */
		const fileTypes = [
			{
				id: 'csv',
				description: t('Squeeze.System.CSV'),
			},
		];

		/** Export/Download the translation file
		 * @param fileType
		 */
		const startTranslationFileDownload = (fileType: string) => {
			loading.value = true;
			translationsApi.getTranslationsExport(fileType.toUpperCase())
				.then((response: Response) => {
					window.open(response.url);
				})
				.catch((response: Response) => response.json().then ((err: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				}))
				.finally(() => {
					loading.value = false;
				})
		}

		return {
			fileTypes,
			loading,
			startTranslationFileDownload,
		};
	},
});
</script>

<style scoped>

.child-content {
	height: calc(100vh - 5.6rem - 4.1rem);
}

</style>
